import React from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import {Grid} from 'semantic-ui-react';

const CollapseMenu = (props) => {
  const { open } = useSpring({ open: props.navbarState ? 0 : 1 });

  if (props.navbarState === true) {
    return (
      <CollapseWrapper style={{
        transform: open.interpolate({
          range: [0, 0.2, 0.3, 1],
          output: [0, -20, 0, -200],
        }).interpolate(openValue => `translate3d(0, ${openValue}px, 0`),
      }}
      >
        <NavLinks>
          <Grid className="burger-menu-wrapper">
            <Grid.Column width={8}>
              <li><NavLink onClick={props.handleNavbar} exact className="item" to="/" >Home</NavLink></li>
              <li><NavLink onClick={props.handleNavbar} className="item" to="/tours">Tours</NavLink></li>
              <li><NavLink onClick={props.handleNavbar} className="item" to="/travelstories">Travel Stories</NavLink></li>
              <li><NavLink onClick={props.handleNavbar} className="item" to="/destinations">Destinations</NavLink></li>
            </Grid.Column>
            <Grid.Column width={8}>
              <li><a onClick={props.handleNavbar} className="item" href="https://www.instagram.com/lightmilestravel/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><NavLink onClick={props.handleNavbar} className="item" to="/aboutus">About us</NavLink></li>
              <li><NavLink onClick={props.handleNavbar} className="item" to="/contactus">Contact us</NavLink></li>
            </Grid.Column>
          </Grid>
        
         
        </NavLinks>
      </CollapseWrapper>
    );
  }
  return null;
};

export default CollapseMenu;

const CollapseWrapper = styled(animated.div)`
  background: #2d3436;
  position: fixed;
  top: 4.5rem;
  left: 0;
  right: 0;
`;

const NavLinks = styled.ul`
  list-style-type: none;
  padding: 2rem 1rem 2rem 2rem;
  
  & li {
    transition: all 300ms linear 0s;
  }

  & a {
    font-size: 1.4rem;
    line-height: 2;
    color: #dfe6e9;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #fdcb6e;
      border-bottom: 1px solid #fdcb6e;
    }
  }
`;

